import { all, fork, takeLeading } from 'redux-saga/effects';
import { sliceName } from '../redux/reportsSlice';
import * as Sagas from './saga';

function* watchFetchFunnel() {
    yield takeLeading(
        `${sliceName}/fetchFunnel`,
        Sagas.fetchFunnelSaga
    );
}

function* watchFetchTimeToHire() {
    yield takeLeading(
        `${sliceName}/fetchTimeToHire`,
        Sagas.fetchTimeToHireSaga
    );
}

function* watchFetchReportFilterOptions() {
    yield takeLeading(
        `${sliceName}/fetchReportFilterOptions`,
        Sagas.fetchReportFilterOptionsSaga
    );
}

function* watchFetchSourceOfHireStats() {
    yield takeLeading(
        `${sliceName}/fetchSourceOfHireStats`,
        Sagas.fetchSourceOfHireStatsSaga
    );
}

function* watchFetchSourceOfHireChart() {
    yield takeLeading(
        `${sliceName}/fetchSourceOfHireChart`,
        Sagas.fetchSourceOfHireChartSaga
    );
}

export function* reportsSagas() {
    yield all([
        fork(watchFetchFunnel),
        fork(watchFetchTimeToHire),
        fork(watchFetchReportFilterOptions),
        fork(watchFetchSourceOfHireStats),
        fork(watchFetchSourceOfHireChart),
    ]);
}
